import { PLAN_TASK_LIST, PLAN_TASK_VARIANTS } from './constants.tsx';

export const PLAN = {
	taskList: PLAN_TASK_LIST,
	taskVariants: PLAN_TASK_VARIANTS,
} as const;
